import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

const DialogContentStyle = () => ({
  padding: '0',
  overflowX: 'hidden'
});

export const Wrapper = styled(Box)(WrapperStyle);
export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
